"use client";

import { Box, Button, Center, Icon, Spinner, Text } from "@chakra-ui/react";
import { PdfViewer } from "@/_components/ui/PdfViewer/PdfViewer";
import { useTranslations } from "next-intl";
import { FaWandSparkles } from "react-icons/fa6";
import { RESUME_DETAIL_RESUME_NS } from "./constants";
import { PlaceholderImage } from "@/_components/ui/PlaceholderImage";

export interface ATSVersionContentProps {
  atsFileUrl?: string;
  isLoading: boolean;
  onGenerate: () => void;
  isGenerating: boolean;
}

export function ATSVersionContent({
  atsFileUrl,
  isLoading,
  onGenerate,
  isGenerating,
}: ATSVersionContentProps) {
  const t = useTranslations(RESUME_DETAIL_RESUME_NS);

  if (isLoading) {
    return (
      <Box
        boxSize="full"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Spinner size="lg" colorPalette="primary" />
      </Box>
    );
  }

  if (atsFileUrl) {
    return (
      <Box
        boxSize="full"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Box h="100%" w="full">
          <PdfViewer fileUrl={atsFileUrl} />
        </Box>
      </Box>
    );
  }

  return (
    <Center flexDirection="column" h="full" gap={4} p={8} textAlign="center">
      <Box p={4} rounded="2xl">
        <PlaceholderImage
          image="designing-a-website"
          height="200px"
          width="200px"
        />
      </Box>
      <Box mb={4}>
        <Text
          fontWeight="semibold"
          fontSize="md"
          mb={1}
          color="themeColor.fg.muted"
        >
          {t("ats_generate.no_ats_title")}
        </Text>
        <Text color="themeColor.fg.muted" fontSize="sm" maxW="340px">
          {t("ats_generate.no_ats_description")}
        </Text>
      </Box>
      <Button
        size="sm"
        colorPalette="primary"
        loading={isGenerating}
        onClick={onGenerate}
      >
        <Icon as={FaWandSparkles} />
        {t("ats_generate.create_button")}
      </Button>
    </Center>
  );
}
